import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PrivateRoute } from 'src/router';

import { SupplierCostFormController } from './suppliers/cost/supplier-cost-form.controller';
import { SupplierInvoiceFormController } from './suppliers/invoice/supplier-invoice-form.controller';
import { SupplierPaymentList } from 'src/app/accounting/suppliers/payment/supplier-payment-list';

import { ClientInvoiceList } from 'src/app/accounting/clients/client-invoice-list';
import { ClientPaymentList } from 'src/app/accounting/clients/client-payment-list';

import { AgentInvoiceList } from 'src/app/accounting/agents/agent-invoice-list';
import { AgentPaymentList } from 'src/app/accounting/agents/agent-payment-list';

import * as Permissions from '../permissions';

export class AccountingController extends React.Component<RouteComponentProps<any>, any> {
	render(): React.ReactNode {
		const match = this.props.match;
		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/suppliers-costs`}
					component={SupplierCostFormController}
					permissions={Permissions.invoiceWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/suppliers-invoices`}
					component={SupplierInvoiceFormController}
					permissions={Permissions.paymentWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/suppliers-payments`}
					component={SupplierPaymentList}
					permissions={Permissions.paymentWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/clients-invoices`}
					component={ClientInvoiceList}
					permissions={Permissions.invoiceWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/clients-payments`}
					component={ClientPaymentList}
					permissions={Permissions.paymentWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/agents-invoices`}
					component={AgentInvoiceList}
					permissions={Permissions.invoiceWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/agents-payments`}
					component={AgentPaymentList}
					permissions={Permissions.paymentWritePermission}
					{...this.props}
				/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/accounting.controller.tsx